<template>
  <div class="p">
    <el-avatar v-if="url" :src="profile(url)" class="wx-avatar" :size="35"></el-avatar>
    <img v-else src="../assets/imgs/unlogin.svg">
  </div>
</template>

<script>
export default {
  name: "WechatAvatar",
  props: {
    url: {
      type: String
    }
  },
  methods: {
    profile (url) {
      return url.startsWith('http') ? url : this.oss + url;
    }
  }
}
</script>

<style scoped>
.el-avatar > img, .p img {
  width: 35px;
  height: 35px;
}

</style>